import { Box } from "@mui/material";

import { Logo } from "../../../shared";

export const Main = () => {
  return (
    <Box sx={{ display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center", height: "100%" }}>
      <a href="https://cascadify.io" target={"_blank"} rel="noreferrer">
        <Logo width={700} height={700} />
      </a>
    </Box>
  );
};
